import { useState, useCallback } from "react";

function useForceUpdate() {
  const [, forceUpdate] = useState(true);

  return useCallback(() => {
    forceUpdate((s) => !s);
  }, []);
}

export { useForceUpdate };
